function resolveNutritionPlanDateValue(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return new Date(value.getTime());
  }

  if (typeof value?.toDate === "function") {
    const resolvedDate = value.toDate();
    return resolvedDate instanceof Date ? resolvedDate : new Date(resolvedDate);
  }

  return new Date(value);
}

export function formatNutritionPlanUpdatedDate(updatedAt, language = "en") {
  const parsedDate = resolveNutritionPlanDateValue(updatedAt);
  if (!(parsedDate instanceof Date) || !Number.isFinite(parsedDate.getTime())) {
    return "";
  }

  return parsedDate.toLocaleDateString(
    String(language).toLowerCase().startsWith("es") ? "es-ES" : "en-US",
    {
      day: "numeric",
      month: "short",
    },
  );
}

export default formatNutritionPlanUpdatedDate;
